import { cn } from 'components/UI/cn'
import { PiUser, PiUsersThree } from 'react-icons/pi'

export type InboxTab = 'my_emails' | 'all_team_emails'

interface InboxTabsProps {
  selectedTab: InboxTab
  onTabChange: (tab: InboxTab) => void
}

const tabs: { key: InboxTab; label: string; icon: React.ReactNode }[] = [
  {
    key: 'my_emails',
    label: 'My Emails',
    icon: <PiUser className="size-[22px]" />,
  },
  {
    key: 'all_team_emails',
    label: 'All Team Emails',
    icon: <PiUsersThree className="size-[22px]" />,
  },
]

/** Tab bar toggling between "My Emails" and "All Team Emails" views. */
export function InboxTabs({ selectedTab, onTabChange }: InboxTabsProps) {
  return (
    <div className="flex border-b border-[#EDEFF1]">
      {tabs.map(({ key, label, icon }) => {
        const isActive = selectedTab === key
        return (
          <button
            key={key}
            type="button"
            onClick={() => onTabChange(key)}
            className={cn(
              'flex items-center gap-2 px-4 h-[54px] text-sm tracking-[-0.14px] select-none transition-colors relative',
              isActive
                ? 'font-medium text-[#06512f]'
                : 'font-medium text-black/[0.54] hover:bg-[#F3F3F3]'
            )}
          >
            {icon}
            {label}
            {isActive && (
              <span className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#06512f] rounded-t-[5px]" />
            )}
          </button>
        )
      })}
    </div>
  )
}
